<script setup lang="ts"></script>
<template>
    <div class="rounded-xl border border-gray-200 bg-white px-5 pb-9 pt-7 shadow-default">
        <slot />
    </div>
</template>
